import React from 'react'
import Header from './Reusables/Header'
import DownloadImg from "../assests/download.svg";
import BUHBudgetTable from './Tables/BUHBudgetTable';
import axiosRequest from "../api/axios";
import SnackBarComponent from "./Helpers/SnackBarComponent";
import CircularProgress from "@mui/material/CircularProgress";
import OverviewTable from "./Tables/Overviewsum"
import { CSVLink } from "react-csv";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import "../index.css";
import PeriodSelector from './PeriodSelector';
const BUHBudgetSummary = () => {
  const [filtersData, setfiltersData] = React.useState({});
  const [filtersDataSum, setfiltersDataSum] = React.useState({});
  const [brandListData, setbrandListData] = React.useState([]);
  const [productListData, setproductListData] = React.useState([]);
  const [selectedProduct, setselectedProduct] = React.useState("");
  const [selectedBrand, setselectedBrand] = React.useState("");
  const [dataLoaded, setdataLoaded] = React.useState(false);
  const [filtersOutputData, setfiltersOutputData] = React.useState({});
  const [severity, setSeverity] = React.useState("");
  const [content, setContent] = React.useState("");
  const [opensb, setOpensb] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [rows, setrows] = React.useState([]);
  const [Quarter, setQuarter] = React.useState("");
  const [Month1, setMonth1] = React.useState("");
  const [Month2, setMonth2] = React.useState("");
  const [Month3, setMonth3] = React.useState("");
  const [showOverviewModal, setshowOverviewModal] = React.useState(false);
  const [loaderFilter, setLoaderFilter] = React.useState(false);
  let sum_data = {
    "m1_qty_sum" :0,
    "m1_value_sum" :0,
    "m1_nsp_sum" :0 ,
    "m2_qty_sum" : 0 ,
    "m2_value_sum" :0 ,
    "m2_nsp_sum" :0 ,
    "m3_qty_sum" : 0 ,
    "m3_value_sum" :0 ,
    "m3_nsp_sum" :0
  }
  const api_headers = {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer '+localStorage.getItem("Token")
  }

  let brandComponent = [];
  brandListData.forEach((item, index) => {
    brandComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
 
  let productComponent = [];
  productListData.forEach((item, index) => {
    productComponent.push(
      <option value={item} key={index}>
        {item}
      </option>
    );
  });
  const handleChangeBrand = (event) => {
    const temp = event.target.value;
    let prodlist=[]
    for (let item of filtersData) { 
      if(item['brandname'] == temp){
        if(event.target.value == "All"){
          prodlist = [...item["productname"]]
        }else{
          prodlist = ["All",...item["productname"]]
        }
        
      }
    }
   
    setproductListData(prodlist)
    setselectedProduct(prodlist[0])
    setselectedBrand(temp);
   
  };
  
 
  const handleClose = () => {
    setOpensb(false);
  };
  const handleCloseOverviewModal = () => {
    setshowOverviewModal(false);
  };

  const handleOverviewModal = () => {
    setshowOverviewModal(true);
    
   
  };

  const handleChangeProduct = (event) => {
    const temp = event.target.value;
    setselectedProduct(temp);
   
  };
  const handleSnackBar = (content, severity) => {
    setOpensb(true);
    setSeverity(severity);
    setContent(content);
  };
  const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    height: 300,
    bgcolor: "background.paper",
    border: "none",
    boxShadow: 24,
    p: 2,
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
  };

  const handleApply = async () => {
    setLoader(true);
    await axiosRequest({
      url: "bu_head_app/buhbudgetfiltersoutputdata",
      method: "POST",
      headers: api_headers,
      data: {
        brandname: selectedBrand,
        prodname:selectedProduct,
        teamcode: localStorage.getItem("teamcode"),
        quarter:localStorage.getItem("quarter"),
        year:localStorage.getItem("year")
      },
    }).then((data) => {
      if (data.status === 200) {
        setLoader(false);
        setrows(data?.data?.data);
        let tot_data = data?.data?.data
        let m1_qty_sum = 0 
        let m1_value_sum =0 
        let m1_nsp_sum =0 
        let m2_qty_sum = 0 
        let m2_value_sum =0 
        let m2_nsp_sum =0 
        let m3_qty_sum = 0 
        let m3_value_sum =0 
        let m3_nsp_sum =0 
        
        for (let i = 0; i < tot_data?.length; i++) { 
          m1_qty_sum = m1_qty_sum+ parseFloat(tot_data[i]["m1_qty"] != null ? tot_data[i]["m1_qty"] : 0)
          m1_value_sum = m1_value_sum + parseFloat(tot_data[i]["m1_value"] != null ? tot_data[i]["m1_value"] : 0)
          m1_nsp_sum = m1_nsp_sum + parseFloat(tot_data[i]["m1_nsp"] != null ? tot_data[i]["m1_nsp"] : 0)
          m2_qty_sum = m2_qty_sum+ parseFloat(tot_data[i]["m2_qty"] != null ? tot_data[i]["m2_qty"] : 0)
          m2_value_sum = m2_value_sum + parseFloat(tot_data[i]["m2_value"] != null ? tot_data[i]["m2_value"] : 0)
          m2_nsp_sum = m2_nsp_sum + parseFloat(tot_data[i]["m2_nsp"] != null ? tot_data[i]["m2_nsp"] : 0)
          m3_qty_sum = m3_qty_sum+ parseFloat(tot_data[i]["m3_qty"] != null ? tot_data[i]["m3_qty"] : 0)
          m3_value_sum = m3_value_sum + parseFloat(tot_data[i]["m3_value"] != null ? tot_data[i]["m3_value"] : 0)
          m3_nsp_sum = m3_nsp_sum + parseFloat(tot_data[i]["m3_nsp"] != null ? tot_data[i]["m3_nsp"] : 0)
        }
        sum_data['m1_qty_sum'] = parseFloat(m1_qty_sum).toFixed( 2 );
        sum_data['m1_value_sum'] = parseFloat(m1_value_sum).toFixed( 2 );
        sum_data['m1_nsp_sum'] =  parseFloat(m1_nsp_sum).toFixed( 2 );
        sum_data['m2_qty_sum'] =  parseFloat(m2_qty_sum).toFixed( 2 );
        sum_data['m2_value_sum'] = parseFloat(m2_value_sum).toFixed( 2 );
        sum_data['m2_nsp_sum'] =  parseFloat(m2_nsp_sum).toFixed( 2 );
        sum_data['m3_qty_sum'] =  parseFloat(m3_qty_sum).toFixed( 2 );
        sum_data['m3_value_sum'] =  parseFloat(m3_value_sum).toFixed( 2 );
        sum_data['m3_nsp_sum'] =  parseFloat(m3_nsp_sum).toFixed( 2 );
        setfiltersDataSum(sum_data)
        console.log(sum_data,"sums")
        handleSnackBar("Data Loaded Successfully", "success");
        // setfiltersOutputData()
       
      } else {
        
        handleSnackBar("Something went wrong! ", "error");
      }
    });
  };


  const getfiltersdata = async () => {
    setLoaderFilter(true);
    await axiosRequest({
      url: "bu_head_app/getfiltersdatabudget",
      method: "POST",
      headers: api_headers,
      data: {
        teamcode: localStorage.getItem("teamcode"),
        quarter:localStorage.getItem("quarter"),
        year:localStorage.getItem("year")

      },
    }).then((data) => {
      if (data.status === 200) {
        const temp_list = [];

        setfiltersData(data?.data?.data);
       
        for (let brand of data?.data?.data) {
          temp_list.push(brand["brandname"]);
        }
        setbrandListData(temp_list)
       
        setdataLoaded(true);
        setLoaderFilter(false);
      } else {
        // setLoader(false);
        // handleSnackBar("No Data Found", "error");
        setdataLoaded(false);
        setLoaderFilter(false);
        
      }
    });
  };
  React.useEffect(() => {
    getfiltersdata();
    // gettabledata();
    setQuarter(localStorage.getItem('quarter'))
    //logic to display month name based on Quarter
    if (localStorage.getItem('quarter') == "Q1") {
      setMonth1("Jan");
      setMonth2("Feb");
      setMonth3("Mar");
    } else if (localStorage.getItem('quarter') == "Q2") {
      setMonth1("Apr");
      setMonth2("May");
      setMonth3("Jun");
    } else if (localStorage.getItem('quarter') == "Q3") {
      setMonth1("Jul");
      setMonth2("Aug");
      setMonth3("Sep");
    } else if (localStorage.getItem('quarter') == "Q4") {
      setMonth1("Oct");
      setMonth2("Nov");
      setMonth3("Dec");
    }
  }, [localStorage.getItem("quarter"),localStorage.getItem("year")]);
  let columns_buh = [
    { key: "id", label: "ID" },
    {
      key: 'prodcode',
      label: 'Prod code',
     
    },
    {
      key: 'proddesc',
      label: 'Product Description',
      
    },
    {
      key: 'proxycode',
      label: 'Proxy code',
      
    },
    {
      key: 'brand',
      label: 'Brand',
      
    },
    {
      key: 'm1_qty',
      label: String(Month1)+' Quantity',
     
    },
    {
      key: 'm1_value',
      label: String(Month1)+' Value',
      
    },
    {
      key: 'm1_nsp',
      label: String(Month1)+' NSP',
      
    },
    {
      key: 'm2_qty',
      label: String(Month2)+' Quantity',
      
    },
    {
      key: 'm2_value',
      label: String(Month2)+' Value',
     
    },
    {
      key: 'm2_nsp',
      label: String(Month2)+' NSP',
    },
    {
      key: 'm3_qty',
      label: String(Month3)+' Quantity',
    },
     
    {
      key: 'm3_value',
      label: String(Month3)+' Value',
      
    },
    {
      key: 'm3_nsp',
      label: String(Month3)+' NSP',
    },
    
    
  ];
  return (
    <div className='bg-white home-screen'>
      <p style={{fontWeight:"550"}}>BUH Budget</p>
       <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <PeriodSelector/>
        <div
          style={{ display: "flex", marginRight: "30px", marginBottom: "20px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Brand Name
            </label>
            <select
              className="filter-style"
              id="brand"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeBrand(event)}
              value={selectedBrand}
            >
              {loaderFilter === true ? (
                <option value="">
                  Loading...
                </option>
              ) : (
                <option value="">select brand name</option>
                
              )}
              {brandComponent}
            </select>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "7px",
            }}
          >
            <label style={{ fontSize: "small", marginBottom: "5px" }}>
              Product Name
            </label>
            <select
              className="filter-style"
              id="product"
              style={{ marginRight: "5px", width: "200px" }}
              onChange={(event) => handleChangeProduct(event)}
              value={selectedProduct}
            >
               <option value="">select Product</option>
               {/* <option value="All">All</option> */}
              {productComponent}
            </select>
          </div>
          
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <button className="submit-btn" onClick={handleApply}>
              Apply
            </button>
          </div>
        </div>
        <div>
          <button
            className="download-btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            
          >
            <img
              src={DownloadImg}
              alt=""
              style={{ marginRight: "6px", height: "12px" }}
            />
            <CSVLink data={rows} headers={columns_buh} filename={"BUHBudget Summary.csv"} style={{textDecoration:"none",color:"black"}}>Download</CSVLink>
          </button>
        </div>
      </div>
      {loader === true ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "150px",
          }}
        >
          <CircularProgress color="inherit" display={loader===true?"true":"false"} />
        </div>
      ):(
        
      <BUHBudgetTable rows={rows} Month1={Month1}
      Month2={Month2} 
      Month3={Month3}/>)}
        {/* <Modal
        open={showOverviewModal}
        onClose={handleCloseOverviewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style1}>
          <CloseIcon
            onClick={handleCloseOverviewModal}
            style={{
              marginLeft: "370px",
              color: "grey",
              alignSelf: "flex-end",
              cursor: "pointer",
            }}
          />
          <h3>Total Overview :</h3>
          <div
            style={{
              display: "flex",
              fontSize: "15px",
              paddingRight: "100px",
              marginBottom: "10px",
            }}
          >
            <p style={{ marginRight: "20px" }}>
              {" "}
              Quantity ({Month1}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                  marginLeft: "10px",
                }}
              >
                {filtersDataSum['m1_qty_sum']}
              </span>
            </p>
            <p>
              {" "}
              Value ({Month1}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                }}
              >
                {filtersDataSum['m1_value_sum']}
              </span>
            </p>
            <p style={{ marginLeft: "20px" }}>
              {" "}
              NSP ({Month1}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                }}
              >
                {filtersDataSum['m1_nsp_sum']}
              </span>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              fontSize: "15px",
              paddingRight: "100px",
              marginBottom: "10px",
            }}
          >
            <p style={{ marginRight: "20px" }}>
              {" "}
              Quantity ({Month2}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                  marginLeft: "10px",
                }}
              >
                {filtersDataSum['m2_qty_sum']}
              </span>
            </p>
            <p>
              {" "}
              Value ({Month2}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                }}
              >
                {filtersDataSum['m2_value_sum']}
              </span>
            </p>
            <p style={{ marginLeft: "20px" }}>
              {" "}
              NSP ({Month2}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                }}
              >
                {filtersDataSum['m2_nsp_sum']}
              </span>
            </p>
          </div>
          <div
            style={{
              display: "flex",
              fontSize: "15px",
              paddingRight: "100px",
              marginBottom: "10px",
            }}
          >
            <p style={{ marginRight: "20px" }}>
              {" "}
              Quantity ({Month3}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                  marginLeft: "10px",
                }}
              >
                {filtersDataSum['m3_qty_sum']}
              </span>
            </p>
            <p>
              {" "}
              Value ({Month3}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                }}
              >
                {filtersDataSum['m3_value_sum']}
              </span>
            </p>
            <p style={{ marginLeft: "20px" }}>
              {" "}
              NSP ({Month3}) :{" "}
              <span
                style={{
                  fontWeight: "bold",
                  border: "solid thin #fd7d21",
                  padding: "5px",
                }}
              >
                {filtersDataSum['m3_nsp_sum']}
              </span>
            </p>
          </div>
          
          

          {/* <div style={{display:"flex"}}>Unadjusted Budget Total ({Month2}) : </div>
          <div style={{display:"flex"}}>Unadjusted Budget Total ({Month3}) : </div> */}
        {/* </Box>
      </Modal> */} 
      {loader === false ?(<div
        style={{
         
         height:"135px",
         width:"100%",
         marginBottom:"10px"
         
        }}
      >
      <table className='table-buh'>
  <tr className="table-tr-td-buh">
  <th className="table-tr-td-buh"></th>
  <th className="table-tr-td-buh">({Month1}) U</th>
    <th className="table-tr-td-buh">({Month1}) V</th>
    <th className="table-tr-td-buh">({Month1}) NSP</th>
    <th className="table-tr-td-buh">({Month2}) U</th>
    <th className="table-tr-td-buh">({Month2}) V</th>
    <th className="table-tr-td-buh">({Month2}) NSP</th>
    <th className="table-tr-td-buh">({Month3}) U</th>
    <th className="table-tr-td-buh">({Month3}) V</th>
    <th className="table-tr-td-buh">({Month3}) NSP</th>
  </tr>
  <tr className="table-tr-td-buh">
    <td className="table-tr-td-buh">Total</td>
    <td className="table-tr-td-buh">{filtersDataSum['m1_qty_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m1_value_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m1_nsp_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m2_qty_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m2_value_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m2_nsp_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m3_qty_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m3_value_sum']}</td>
    <td className="table-tr-td-buh">{filtersDataSum['m3_nsp_sum']}</td>
  </tr>
</table>
      </div>):""}
      <SnackBarComponent
        opensb={opensb}
        handleClose={handleClose}
        severity={severity}
        content={content}
        autoHideDuration={6000}
      />
    </div>
  )
}

export default BUHBudgetSummary
